import { useLingui } from '@lingui/react';
import { scrollNextField } from '../../../helpers/scrollNextField';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const TextButton = _ref => {
  let {
    text = ''
  } = _ref;
  const {
    i18n
  } = useLingui();
  const title = i18n._('carlead.textButton.headline');
  // eslint-disable-next-line no-unused-vars
  const ctaLabel = i18n._('carlead.textButton.button.label');
  const handleScroll = () => {
    scrollNextField();
  };
  return /*#__PURE__*/_jsx("div", {
    className: "box gap white",
    children: /*#__PURE__*/_jsx("div", {
      className: "container",
      children: /*#__PURE__*/_jsxs("section", {
        className: "text-button text-center",
        children: [/*#__PURE__*/_jsx("h2", {
          className: "section-title",
          children: title
        }), /*#__PURE__*/_jsx("p", {
          children: text
        }), /*#__PURE__*/_jsxs("button", {
          className: "btn btn-secondary btn-lg btn-arrow goToNextField",
          onClick: handleScroll,
          "data-tracking": "true",
          "data-action": "Click",
          "data-label": "CTA - Sell Stress Free",
          children: [ctaLabel, /*#__PURE__*/_jsx("svg", {
            className: "svg-icon ml-2",
            xmlns: "http://www.w3.org/2000/svg",
            width: "1em",
            height: "1em",
            viewBox: "0 0 32 32",
            children: /*#__PURE__*/_jsx("path", {
              d: "m23.999 18 2-2-16-16L6 3.999 17.998 16 6 28.001 9.999 32l14-14z"
            })
          })]
        })]
      })
    })
  });
};
export default TextButton;